import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Pipe({ name: 'formErrors', pure: false })
export class FormErrorsPipe implements PipeTransform {
  transform(control: AbstractControl | null): string[] {
    if (!control?.errors) return [];

    const errors = control.errors;
    const messages: Record<string, () => string> = {
      required:    () => 'Este campo es obligatorio',
      email:       () => 'El correo no es válido',
      min:         () => `El valor mínimo es ${errors['min'].min}`,
      max:         () => `El valor máximo es ${errors['max'].max}`,
      minlength:   () => `Mínimo ${errors['minlength'].requiredLength} caracteres`,
      maxlength:   () => `Máximo ${errors['maxlength'].requiredLength} caracteres`,
      serverError: () => errors['serverError'],
    };

    return Object.keys(control.errors)
      .filter(key => messages[key])
      .map(key => messages[key]());
  }
}
